<div mat-dialog-content>

  <div class="car-price">
    <div class="section-title">
      <h3> Historique Prix</h3>

    </div>

    @if (!(data.priceHistory.length > 0)) {
      <h6>
        Aucun historique de prix
      </h6>
    }

    <!-- <span *ngFor="let prix of car.priceHistory">
    {{ moneyFormat(""+prix.amount)}} FCFA le {{dateFormat(""+prix.date)}}

  </span> -->
  <div class="table-list">
    @if (data.priceHistory.length > 0) {
      <table mat-table [dataSource]="data.priceHistory.slice().reverse()">
        <ng-container matColumnDef="date">
          <th mat-header-cell *matHeaderCellDef> Date </th>
          <td mat-cell *matCellDef="let element"> {{dateFormat(""+element.date)}} </td>
        </ng-container>
        <ng-container matColumnDef="amount">
          <th mat-header-cell *matHeaderCellDef> Prix </th>
          <td mat-cell *matCellDef="let element"> {{moneyFormat(element.amount)}} {{element.currency}}@if (data.businessLine===CarBusinessLine.RENT) {
            <span>/J</span>
          }</td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="['date', 'amount']"></tr>
        <tr mat-row *matRowDef="let row; columns: ['date', 'amount'];"></tr>
      </table>
    }
  </div>
</div>

</div>
